import { render, staticRenderFns } from "./SubFamily.vue?vue&type=template&id=7967bf91"
import script from "./SubFamily.vue?vue&type=script&lang=js"
export * from "./SubFamily.vue?vue&type=script&lang=js"
import style0 from "./SubFamily.vue?vue&type=style&index=0&id=7967bf91&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports